import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import React, { createContext } from "react";
//import Home from './Pages/Home.tsx';
import Login from './Pages/Login.tsx';
import Register from './Pages/Register.tsx';
import WelcomePage from './Pages/WelcomePage.tsx';
import TenantManagement from './Pages/Admin/TenantManagement.tsx';
import TenantSelection from './Pages/Admin/TenantSelection.tsx';
import UserManager from './Pages/Admin/UserManager.tsx';
import ResetPassword from './Pages/ResetPassword.tsx';
import ForgotPassword from './Pages/ForgotPassword.tsx';
import ProjectCharter from './Pages/Charter.tsx';
import PageLayout from './Pages/PageLayout.tsx';
import ProtectedRoutes from './utils/ProtectedRoutes.tsx';
import AdminProtectedRoute from './utils/AdminProtectedRoute.tsx';
import { ThemeProvider } from './Components/theme-provider.tsx';
import Settings from './Pages/Settings.tsx';
import Team from './Pages/Team.tsx';
import Plan from './Pages/Plan.tsx';
import SupportReuqests from './Pages/SupportRequests.tsx';
import Risks from './Pages/Risks.tsx';
import Issues from './Pages/Issues.tsx';
import Training from './Pages/Training.tsx';
import RagGuidelines from './Pages/RagGuidelines.tsx';
import Help from './Pages/Help.tsx';
import Policies from './Pages/Policies.tsx';
import Actions from './Pages/Actions.tsx';
import Decisions from './Pages/Decisions.tsx';
import UpcomingDeliverables from './Pages/UpcomingDeliverables.tsx';
import StatusReport from './Pages/StatusReport.tsx';
import Reports from './Pages/Reports.tsx';

function App() {

    return (
        <AppProvider>
            <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
                <BrowserRouter>
                    <Routes>
                        <Route element={<ProtectedRoutes />} >
                            <Route path="/" element={<PageLayout />} >
                                <Route path="/" element={<MultiProjectDash />} />
                                <Route path="/ProjectOverview" element={<ProjectOverview />} />
                                <Route path="/StatusReports" element={<StatusReport />} />
                                <Route element={<AuthorisedRoute authorisedRoles={[2, 3, 4, 5]} />}>
                                    <Route path="/UpcomingDeliverables" element={<UpcomingDeliverables />} />
                                </Route>
                                <Route path="/Charter" element={<ProjectCharter />} />
                                <Route path="/Reports" element={<Reports />} />
                                <Route element={<AuthorisedRoute authorisedRoles={[2, 3, 4, 5]} />}>
                                    <Route path="/SupportRequests" element={<SupportReuqests />} />
                                </Route>
                                <Route element={<AuthorisedRoute authorisedRoles={[2, 3, 4, 5]} />}>
                                    <Route path="/Risks" element={<Risks />} />
                                </Route>
                                <Route element={<AuthorisedRoute authorisedRoles={[2, 3, 4, 5]} />}>
                                    <Route path="/Issues" element={<Issues />} />
                                </Route>
                                <Route element={<AuthorisedRoute authorisedRoles={[2, 3, 4, 5]} />}>
                                    <Route path="/Actions" element={<Actions />} />
                                </Route>
                                <Route element={<AuthorisedRoute authorisedRoles={[2, 3, 4, 5]} />}>
                                    <Route path="/Decisions" element={<Decisions />} />
                                </Route>
                                <Route element={<AuthorisedRoute authorisedRoles={[2, 3, 4, 5]} />}>
                                    <Route path="/Team" element={<Team />} />
                                </Route>

                                <Route element={<AuthorisedRoute authorisedRoles={[2, 3, 4, 5]} />}>
                                    <Route path="/Plan" element={<Plan />} />
                                </Route>

                                <Route path="/Settings" element={<Settings />} />

                                <Route path="/Training" element={<Training />} />
                                <Route path="/RagGuidelines" element={<RagGuidelines />} />
                                <Route path="/Help" element={<Help />} />
                                <Route path="/Policies" element={<Policies />} />
                                <Route path="/NoProjects" element={<NoProjects />} />
                            </Route>
                        </Route>
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/welcome" element={<WelcomePage />} />
                        <Route element={<AdminProtectedRoute />}>
                            <Route path="/admin/tenants" element={<TenantManagement />} />
                            <Route path="/admin/tenants/:tenantId/users" element={<UserManager />} />
                            <Route path="/admin/select-tenant" element={<TenantSelection />} />
                        </Route>
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/reset-password" element={<ResetPassword />} />
                    </Routes>
                </BrowserRouter>
            </ThemeProvider>
        </AppProvider>
    );
}

export default App;

interface AppContextProps {
    taskbarMessage: string;
    showActionNotification: (title: string, description: string, variant: "success" | "info" | "default" | "destructive" | "warning" | null | undefined) => void;
    projects: Project[];
    setProjects: React.Dispatch<React.SetStateAction<Project[]>>;
    workPackageOptions?: WorkPackageOptions[];
    setWorkPackageOptions: (workPackageOptions: WorkPackageOptions[]) => void;
    teamMembers: User[];
    setTeamMembers: (teamMembers: User[]) => void;
    projectManagers: User[];
    setProjectManagers: (projectManagers: User[]) => void;
    sponsors: User[];
    setSponsors: (sponsors: User[]) => void;
    selectedProject: Project | undefined;
    setSelectedProject: (project: Project) => void;
    applicationUser: ApplicationUser | undefined;
    setApplicationUser: (applicationUser: ApplicationUser) => void;
    authLevel: number;
    setAuthLevel: (authLevel: number) => void;
    projectRole: "Viewer" | "Team Member" | "Sponsor" | "Project Manager";
    setProjectRole: (projectRole: "Viewer" | "Team Member" | "Sponsor" | "Project Manager") => void;
    loadUserSettings: () => Promise<ApplicationUser["userSettings"]>;
    updateUserSettings: (key: string, value: string) => void;
}

export const AppContext = createContext<AppContextProps>({
    taskbarMessage: "",
    showActionNotification: () => { },
    projects: [],
    setProjects: () => { },
    workPackageOptions: undefined,
    setWorkPackageOptions: () => { },
    teamMembers: [],
    setTeamMembers: () => { },
    projectManagers: [],
    setProjectManagers: () => { },
    sponsors: [],
    setSponsors: () => { },
    selectedProject: { id: 0, name: "", projectTypeId: 1 },
    setSelectedProject: () => { },
    applicationUser: { id: "", name: "", email: "", role: "", projectUserRoles: [] },
    setApplicationUser: () => { },
    authLevel: 0,
    setAuthLevel: () => { },
    projectRole: "Viewer",
    setProjectRole: () => { },
    loadUserSettings: async () => { return Promise.resolve(undefined); },
    updateUserSettings: () => { },
});

import { ReactNode, useState } from 'react';
import NoProjects from './Pages/NoProjects.tsx';
import { getRoleIdFromRoleName } from './hooks/project-roles.ts';
import AuthorisedRoute from './utils/AuthorisedRoute.tsx';
import { User } from './Components/TeamBuilder/team_table/columns.tsx';
import MultiProjectDash from './Pages/MultiProjectDash.tsx';
import ProjectOverview from './Pages/ProjectOverview.tsx';
import { toast } from './hooks/use-toast.ts';
//import { releaseAllLocks } from './hooks/lock-release.tsx';

interface AppProviderProps {
    children: ReactNode;
}

export const AppProvider = ({ children }: AppProviderProps) => {

    const [taskbarMessage, setTaskbarMessage] = useState("");
    const [projectsList, setProjectsList] = useState<Array<{ id: number; name: string; projectTypeId: number }>>([]);
    const [workPackageOptions, setWorkPackageOptions] = useState<WorkPackageOptions[] | undefined>();
    const [teamMembers, setTeamMembers] = useState<User[]>([]);
    const [projectManagers, setProjectManagers] = useState<User[]>([]);
    const [sponsors, setSponsors] = useState<User[]>([]);
    const [selectedProject, setSelectedProject] = useState<Project | undefined>();
    const [applicationUser, setApplicationUser] = useState<ApplicationUser | undefined>();
    const [authLevel, setAuthLevel] = useState<number>(0);
    const [projectRole, setProjectRole] = useState<"Viewer" | "Team Member" | "Sponsor" | "Project Manager">("Viewer");
    const [projectTypeId, setProjectTypeId] = useState<number>(1); // default to 1, can be changed based on the project type
    const messageDisplayDuration = 5000; // duration in milliseconds for which the taskbar message is displayed

    // Apply visual preferences on initial load
    React.useEffect(() => {
        const applyVisualPreferences = () => {
            // Apply glassmorphism setting
            const glassmorphism = localStorage.getItem('glassmorphism-enabled');
            const glassmorphismEnabled = glassmorphism !== null ? glassmorphism === 'true' : true;
            document.body.setAttribute('data-glassmorphism', glassmorphismEnabled.toString());

            // Apply background pattern setting
            const backgroundPattern = localStorage.getItem('background-pattern-enabled');
            const backgroundPatternEnabled = backgroundPattern !== null ? backgroundPattern === 'true' : true;
            document.body.setAttribute('data-background-pattern', backgroundPatternEnabled.toString());
        };

        applyVisualPreferences();
    }, []);

    React.useEffect(() => {
        if ((applicationUser?.projectUserRoles?.length ?? 0) > 0) {
            // if the user has project roles, populate the projects list
            const plist = applicationUser?.projectUserRoles?.map((pur) => {
                return { id: pur.projectId, name: pur.projectName, projectTypeId: pur.projectTypeId };
            }) ?? [];
            setProjectsList(plist);

            // set the selected project to the first project in the list
            const proj = retrieveUserSelectedProject(plist);
            if (proj) {
                setSelectedProject(proj);
            } else {
                setSelectedProject(plist[0]);
            }
        }
    }, [applicationUser]);

    React.useEffect(() => {
        // if the projects list changes, update the selected project
        const selectedProjectId = selectedProject?.id;

        if (projectsList.length > 0) {
            if (selectedProjectId) {
                const proj = projectsList.find(p => p.id === selectedProjectId);
                if (proj) {
                    setSelectedProject(proj);
                    storeUserSelectedProject();
                }
            } else {
                const proj = retrieveUserSelectedProject(projectsList);
                if (proj) {
                    setSelectedProject(proj);
                } else {
                    setSelectedProject(projectsList[0]);
                }
            }
        }
    }, [projectsList]);

    React.useEffect(() => {
        if (selectedProject?.id) {
            storeUserSelectedProject();
        }
    }, [selectedProject])

    React.useEffect(() => {
        setTimeout(() => {
            setTaskbarMessage("");
        }, messageDisplayDuration);
    }, [taskbarMessage]);

    // React.useEffect(() => {
    //     const handleBeforeUnload = (event: BeforeUnloadEvent) => {
    //         if (applicationUser?.id) {
    //             navigator.sendBeacon(`/Lock/ReleaseAll/${applicationUser.id}`);
    //             // Optionally, show a confirmation dialog (not recommended for most apps)
    //             event.preventDefault();
    //             event.returnValue = '';
    //         }
    //     };
    //     window.addEventListener('beforeunload', handleBeforeUnload);
    //     return () => {
    //         window.removeEventListener('beforeunload', handleBeforeUnload);
    //     };
    // }, [applicationUser]);

    function showActionNotification(title: string, description: string, variant: "success" | "info" | "default" | "destructive" | "warning" | null | undefined) {
        if (applicationUser?.userSettings?.taskbarNotifications) {
            setTaskbarMessage(description);
        } else {
            toast({
                title: title,
                description: description,
                duration: messageDisplayDuration,
                variant: variant,
            });
        }
    }

    function storeUserSelectedProject() {
        const userSelectedProject = { userId: applicationUser?.id, selectedProjectId: selectedProject?.id.toString() }
        window.localStorage.setItem(applicationUser?.id + "_userSelectedProject", JSON.stringify(userSelectedProject));
    }

    function retrieveUserSelectedProject(plist: { id: number; name: string; projectTypeId: number }[]) {
        const localStorageValue = localStorage.getItem(applicationUser?.id + "_userSelectedProject");
        if (localStorageValue) {
            const retrievedUserSelectedProject = JSON.parse(localStorageValue);
            if (retrievedUserSelectedProject.userId === applicationUser?.id) {
                return plist.find(p => p.id === +retrievedUserSelectedProject.selectedProjectId); // the stored value is a string, the + at the beginning parses it as a number
            }
        }
        return plist[0];
    }

    async function loadUserSettings(): Promise<ApplicationUser["userSettings"]> {
        if (applicationUser) {
            try {
                const response = await fetch(`Users/settings`);
                const data = await response.json();

                const userSettings = data ? {
                    dashboardElements: data.dashboardElements,
                    // dashboardProjects is a comma-separated string of project IDs, convert it to an array of numbers
                    // if the string is empty, set it to all project IDs
                    dashboardProjects: data.dashboardProjects ? data.dashboardProjects.split(',').map((id: string) => parseInt(id, 10)) : projectsList.map(p => p.id),
                    taskbarNotifications: data.taskbarNotifications ?? false,
                    inlineTableEditing: data.inlineTableEditing ?? false,
                    tutorialsCompleted: data.tutorialsCompleted ?? 0
                } : {
                    dashboardElements: undefined,
                    dashboardProjects: undefined,
                    taskbarNotifications: false,
                    inlineTableEditing: false,
                    tutorialsCompleted: 0
                };

                // Create a new applicationUser object to trigger React re-render
                const updatedUser = { ...applicationUser, userSettings };
                setApplicationUser(updatedUser);
                
                return userSettings;
            } catch (error) {
                console.error("Error loading user settings:", error);
                // if there is an error, set the user settings to undefined
                const defaultSettings = {
                    dashboardElements: undefined,
                    dashboardProjects: undefined,
                    taskbarNotifications: false,
                    inlineTableEditing: false,
                    tutorialsCompleted: 0
                };
                
                const updatedUser = { ...applicationUser, userSettings: defaultSettings };
                setApplicationUser(updatedUser);
                
                return defaultSettings;
            }
        }
    }

    function updateUserSettings(key: string, value: string) {
        if (applicationUser) {
            fetch(`Users/settings/${key}/${value}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then((data) => {
                    if (data) {
                        // Create a new applicationUser object to trigger React re-render
                        const updatedUser = { ...applicationUser };
                        
                        // Update the user settings in the new object
                        if (!updatedUser.userSettings) {
                            updatedUser.userSettings = {
                                dashboardElements: data.dashboardElements,
                                dashboardProjects: data.dashboardProjects ? data.dashboardProjects.split(',').map((id: string) => parseInt(id, 10)) : undefined,
                                taskbarNotifications: data.taskbarNotifications ?? false,
                                inlineTableEditing: data.inlineTableEditing ?? false,
                                tutorialsCompleted: data.tutorialsCompleted ?? 0
                            };
                        } else {
                            // Create a new userSettings object
                            updatedUser.userSettings = { ...updatedUser.userSettings };
                            
                            if (key === "dashboardElements") {
                                updatedUser.userSettings.dashboardElements = parseInt(value, 10);
                            } else if (key === "dashboardProjects") {
                                updatedUser.userSettings.dashboardProjects = value ? value.split(',').map((id: string) => parseInt(id, 10)) : undefined;
                            } else if (key === "taskbarNotifications") {
                                updatedUser.userSettings.taskbarNotifications = value === "true";
                            } else if (key === "inlineTableEditing") {
                                updatedUser.userSettings.inlineTableEditing = value === "true";
                            } else if (key === "tutorialsCompleted") {
                                updatedUser.userSettings.tutorialsCompleted = parseInt(value, 10);
                            }
                        }
                        
                        // Update the state to trigger re-render
                        setApplicationUser(updatedUser);
                        showActionNotification("Settings Updated", "Your settings have been updated successfully.", "success");
                    }
                })
                .catch((error) => {
                    console.error("Error updating user settings:", error);
                    showActionNotification("Error", "There was an error updating your settings. Please try again.", "destructive");
                }
                );
        }
    }

    React.useEffect(() => {
        // set auth level based on the user's role
        if (applicationUser?.role === "Admin") {
            setAuthLevel(5);
        } else if (applicationUser?.role === "User") {
            const projectUserRole = applicationUser?.projectUserRoles.find(pur => pur.projectId === selectedProject?.id);
            const projectRole = projectUserRole?.roleName;
            if (projectRole) {
                setProjectRole(projectRole as "Viewer" | "Team Member" | "Sponsor" | "Project Manager");
                setProjectTypeId(projectUserRole.projectTypeId);
            }
            const level = getRoleIdFromRoleName(projectRole as "Viewer" | "Team Member" | "Sponsor" | "Project Manager");
            setAuthLevel(level);
        }
        GetWorkPackageOptions();
        GetProjectTeam();
    }, [selectedProject]);

    function GetWorkPackageOptions() {
        if (selectedProject) {
            fetch("Raids/WorkPackageOptions/" + selectedProject.id)
                .then((response) => response.json())
                .then((data) => {
                    setWorkPackageOptions(data);
                }
                );
        }
    }

    function GetProjectTeam() {
        if (selectedProject) {
            fetch("Projects/ProjectTeam/" + selectedProject.id)
                .then((response) => response.json())
                .then((data) => {
                    setProjectManagers(data.projectManagers);
                    setSponsors(data.sponsors);
                    setTeamMembers(data.teamMembers);
                });
        }
    }

    const contextValue = {
        taskbarMessage,
        showActionNotification,
        projects: projectsList,
        setProjects: setProjectsList,
        workPackageOptions,
        setWorkPackageOptions,
        teamMembers,
        setTeamMembers,
        projectManagers,
        setProjectManagers,
        sponsors,
        setSponsors,
        selectedProject,
        setSelectedProject,
        applicationUser,
        setApplicationUser,
        authLevel,
        setAuthLevel,
        projectRole,
        setProjectRole,
        projectTypeId,
        setProjectTypeId,
        loadUserSettings,
        updateUserSettings
    };

    return (
        <AppContext.Provider value={contextValue}>
            {children}
        </AppContext.Provider>
    );
};

export type Project = {
    id: number;
    name: string;
    projectTypeId: number;
}

export type ApplicationUser = {
    id: string;
    name: string;
    email: string;
    role: string;
    projectUserRoles: ProjectUserRole[];
    userSettings?: {
        dashboardElements: number | undefined;
        dashboardProjects: number[] | undefined;
        taskbarNotifications: boolean | undefined;
        inlineTableEditing?: boolean | undefined;
        tutorialsCompleted: number;
    }
}

export type ProjectUserRole = {
    projectId: number;
    roleName: string;
    projectName: string;
    projectTypeId: number;
}

export type WorkPackageOptions = {
    workstreamId: number;
    workstreamName: string;
    workPackageNames: { workPackageId: number, workPackageName: string }[];
}